const ERR_TOKEN_EXPIRED = -12;
let net = {
    load: function (url, callback, errCallback) {
        fetch(url, {
            method: "GET",
            headers: {
                'Accept': 'application/json; charset=utf-8',
                'Content-Type': 'application/json; charset=utf-8',
                'x-access-token': window.token,
                'lang': global.lang,
                'platform': "WEB",
            }
        }).then(function (response) {
            return response.json()
        }).then(function (ret) {
            console.log("load=====", ret);
            if (ret.result === ERR_TOKEN_EXPIRED) {
                global.goToLogin();
                return;
            }
            let list = ret;
            if (ret.list) {
                list = ret.list;
            }
            list.forEach(function (item) {
                if (item.objectId) {
                    item.id = item.objectId;
                }
            });
            callback(ret);
        }).catch(function (error) {
            if (errCallback) {
                errCallback(error);
            }
            console.log(error);
        }).done();
    },
    loadZip: function (url, callback, errCallback) {
        fetch(url, {
            method: "GET",
            headers: {
                'Accept-Encoding': 'gzip',
                'Content-Type': 'application/json; charset=utf-8',
                'x-access-token': window.token,
                'lang': global.lang,
                'platform': "WEB",
            }
        }).then(function (response) {
            return response.json()
        }).then(function (ret) {
            console.log("loadZip=====", ret);
            if (ret.result === ERR_TOKEN_EXPIRED) {
                global.goToLogin();
                return;
            }
            let list = ret;
            if (ret.list) {
                list = ret.list;
            }
            list.forEach(function (item) {
                if (item.objectId)
                    item.id = item.objectId;
            });
            callback(ret);
        }).catch(function (error) {
            if (errCallback) {
                errCallback(error);
            }
            console.log(error);
        }).done();
    },
    loadOne: function (url, callback, errCallback) {
        fetch(url, {
            method: "GET",
            headers: {
                'Accept': 'application/json; charset=utf-8',
                'Content-Type': 'application/json; charset=utf-8',
                'x-access-token': window.token,
                'lang': global.lang,
                'platform': "WEB",
            }
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            console.log("loadOne=====", data);
            if (data.result === ERR_TOKEN_EXPIRED) {
                global.goToLogin();
                return;
            }
            callback(data);
        }).catch(function (error) {
            console.log(error);
            if (errCallback) {
                errCallback(error);
            }
        }).done();
    },
    get: function (url, callback, errorCallback) {
        fetch(url, {
            headers: {
                'x-access-token': window.token,
                'lang': global.lang,
                'platform': "WEB",
            }
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            console.log("get=====", data);
            if (data.result === ERR_TOKEN_EXPIRED) {
                global.goToLogin();
                return;
            }
            callback(data);
        }).catch(function (error) {
            console.log(error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    },
    delete: function (url, callback, errorCallback) {
        fetch(url, {
            method: "DELETE",
            headers: {
                'x-access-token': window.token,
                'lang': global.lang,
                'platform': "WEB",
            }
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            console.log("delete=====", data);
            if (data.result === ERR_TOKEN_EXPIRED) {
                global.goToLogin();
                return;
            }
            callback(data);
        }).catch(function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    },
    put: function (url, obj, callback, errCallback) {
        // let headers = new Headers();
        // if(global.loginUser)
        //   headers.append("X-API-TOKEN", global.loginUser.token);
        fetch(url, {
            method: "PUT",
            headers: {
                'x-access-token': window.token,
                'lang': global.lang,
                'platform': "WEB",
            },
            body: JSON.stringify(obj)
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            console.log("put=====", data);
            if (data.result === ERR_TOKEN_EXPIRED) {
                global.goToLogin();
                return;
            }
            callback(data);
        }).catch(function (error) {
            console.log(error);
            if (errCallback) {
                errCallback(error);
            }
        });
    },
    post: function (url, data, callback, errCallback) {
        fetch(url, {
            method: "POST",
            headers: {
                'x-access-token': window.token,
                'lang': global.lang,
                'platform': "WEB",
            },
            body: JSON.stringify(data)
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            console.log("post=====", data);
            if (data.result === ERR_TOKEN_EXPIRED) {
                global.goToLogin();
                return;
            }
            callback(data);
        }).catch(function (error) {
            console.log(error);
            if (errCallback) {
                errCallback(error);
            }
        });
    },
    upload: function (url, formData, callback, errCallback, name) {
        // let n = name;
        // if (formData.get) {
        //     n = formData.get('name');
        // }
        fetch(url, {
            method: "POST",
            headers: {
                // "Raw-Name":n,
                'x-access-token': window.token,
                'lang': global.lang,
                'platform': "WEB",
            },
            body: formData
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            callback(data);
        }).catch(function (error) {
            console.log(error);
            if (errCallback) {
                errCallback(error);
            }
        });
    },
    downloadURI: async function (uri, name) {
        console.log("downloadURI=====", uri, name);
        try {
            // 1. 发起带 Token 头的请求，获取文件 Blob 流
            const response = await fetch(uri, {
                method: 'GET', // 根据后端要求调整（如 POST）
                headers: {
                    'x-access-token': window.token,
                    'Accept': 'application/octet-stream', // 告知后端返回二进制流
                    'Content-Type': 'application/json'
                },
                //   credentials: 'include' // 如需携带 Cookie 则添加（如 refreshToken）
            });

            // 2. 校验请求是否成功
            if (!response.ok) {
                throw new Error(`下载失败：${response.status} ${response.statusText}`);
            }

            // 3. 将响应转换为 Blob（二进制文件流）
            const blob = await response.blob();

            // 4. 创建临时下载链接
            const link = document.createElement('a');
            // 生成 Blob 临时 URL（下载完成后需释放）
            const blobUrl = URL.createObjectURL(blob);
            link.href = blobUrl;
            link.download = name; // 设置下载文件名

            // 5. 触发下载
            document.body.appendChild(link);
            link.click();

            // 6. 清理资源
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl); // 释放临时 URL，避免内存泄漏

            console.log(`文件 ${name} 下载触发成功`);
        } catch (error) {
            console.error('下载失败：', error);
            alert(`下载失败：${error.message}`);
        }
    },
    onViewPhoto: async (url) => {
        try {
            // 2. 带 Token 请求图片资源（自定义请求头）
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'x-access-token': window.token,
                    'Accept': 'image/jpeg, image/png, image/*' // 适配图片格式
                }
            });

            // 3. 校验请求是否成功
            if (!response.ok) {
                throw new Error(`请求失败：${response.status}`);
            }

            // 4. 将响应转为 Blob 格式
            const blob = await response.blob();

            // 5. 生成临时 URL（浏览器内有效，关闭页面自动失效）
            const blobUrl = URL.createObjectURL(blob);

            // 6. 打开新窗口展示图片
            const newWindow = window.open(blobUrl, '_blank');

            // 7. 可选：新窗口加载完成后释放临时 URL（避免内存泄漏）
            if (newWindow) {
                newWindow.onload = () => {
                    URL.revokeObjectURL(blobUrl);
                };
            }
        } catch (error) {
            console.error('查看发票图片失败：', error);
            alert('图片加载失败，请重试');
        }
    },
    exportFile: function (url, query, file) {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            var a;
            if (xhttp.readyState === 4 && xhttp.status === 200) {
                // Trick for making downloadable link
                a = document.createElement('a');
                a.href = window.URL.createObjectURL(xhttp.response);
                // Give filename you wish to download
                a.download = file;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
            }
        };
        // Post data to URL which handles post request
        xhttp.open("GET", url);
        xhttp.setRequestHeader("Content-Type", "application/json");
        xhttp.setRequestHeader("x-access-token", window.token);
        xhttp.setRequestHeader("platform", "WEB");
        xhttp.setRequestHeader("lang", global.lang);
        // You should set responseType as blob for binary responses
        xhttp.responseType = 'blob';
        xhttp.send();
    },
    downloadExcel: function (url, file) {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            var a;
            if (xhttp.readyState === 4 && xhttp.status === 200) {
                // Trick for making downloadable link
                a = document.createElement("a");
                a.href = window.URL.createObjectURL(xhttp.response);
                // Give filename you wish to download
                a.download = file;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
            }
        };
        // Post data to URL which handles post request
        xhttp.open("GET", url);
        xhttp.setRequestHeader("Content-Type", "application/json");
        xhttp.setRequestHeader("x-access-token", window.token);
        xhttp.setRequestHeader("platform", "WEB");
        xhttp.setRequestHeader("lang", global.lang);
        // You should set responseType as blob for binary responses
        xhttp.responseType = "blob";
        xhttp.send();
    },
    downloadExcelByFilter: function (url, query, file) {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            var a;
            if (xhttp.readyState === 4 && xhttp.status === 200) {
                // Trick for making downloadable link
                a = document.createElement("a");
                a.href = window.URL.createObjectURL(xhttp.response);
                // Give filename you wish to download
                a.download = file;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
            }
        };
        // Post data to URL which handles post request
        xhttp.open("POST", url);
        xhttp.setRequestHeader("Content-Type", "application/json");
        xhttp.setRequestHeader("x-access-token", window.token);
        xhttp.setRequestHeader("platform", "WEB");
        xhttp.setRequestHeader("lang", global.lang);
        // You should set responseType as blob for binary responses
        xhttp.responseType = "blob";
        xhttp.send(JSON.stringify(query));
    },
    downloadExcelByStandard: function (url, file) {
        console.log('downloadExcelByStandard', url);
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            var a;
            if (xhttp.readyState === 4 && xhttp.status === 200) {
                // Trick for making downloadable link
                a = document.createElement("a");
                a.href = window.URL.createObjectURL(xhttp.response);
                // Give filename you wish to download
                a.download = file;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
            }
        };
        // Post data to URL which handles post request
        xhttp.open("GET", url);
        xhttp.setRequestHeader("Content-Type", "application/json");
        xhttp.setRequestHeader("x-access-token", window.token);
        xhttp.setRequestHeader("platform", "WEB");
        xhttp.setRequestHeader("lang", global.lang);
        // You should set responseType as blob for binary responses
        xhttp.responseType = "blob";
        xhttp.send(JSON.stringify({}));
    },
    downloadExcelByFetch: function (url, query, file) {
        console.log('downloadExcelByFetch', url);
        let token;
        if (global.loginUser && global.loginUser.token) {
            token = global.loginUser.token;
        }

        // 使用 fetch 替代 XMLHttpRequest
        fetch(url, {
            method: "POST",
            headers: {
                // "Content-Type": "application/json",
                "x-access-token": window.token || token
            },
            body: JSON.stringify(query)
        })
            .then(response => {
                if (response.ok) {
                    return response.blob();
                }
                throw new Error('Network response was not ok.');
            })
            .then(blob => {
                // 创建下载链接并触发下载
                const a = document.createElement("a");
                a.href = window.URL.createObjectURL(blob);
                a.download = file;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                // 清理创建的元素
                document.body.removeChild(a);
                window.URL.revokeObjectURL(a.href);
            })
            .catch(error => {
                console.error('Download failed:', error);
            });
    },
    downloadText: function (url, file) {
        console.log('downloadText', url);
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            var a;
            if (xhttp.readyState === 4 && xhttp.status === 200) {
                // Trick for making downloadable link
                a = document.createElement("a");
                a.href = window.URL.createObjectURL(xhttp.response);
                // Give filename you wish to download
                a.download = file;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
            }
        };
        // Post data to URL which handles post request
        xhttp.open("GET", url);
        xhttp.setRequestHeader("Content-Type", "application/json");
        xhttp.setRequestHeader("x-access-token", window.token);
        xhttp.setRequestHeader("platform", "WEB");
        xhttp.setRequestHeader("lang", global.lang);
        // You should set responseType as blob for binary responses
        xhttp.responseType = "blob";
        xhttp.send();
    },
    postDownload: function (url, data, file, errCallback) {
        // let headers = new Headers();
        // if(global.loginUser)
        //   headers.append("X-API-TOKEN", global.loginUser.token);
        fetch(url, {
            method: "POST",
            headers: {
                'x-access-token': window.token,
                'platform': "WEB",
                'lang': global.lang,
            },
            body: JSON.stringify(data)
        }).then(function (response) {
            return response.blob()
        }).then((blob) => {
            var a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            // Give filename you wish to download
            a.download = file;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
        }).catch(function (error) {
            console.log(error);
            if (errCallback) {
                errCallback(error);
            }
        });
    },
    downloadFile: function (url, fileName) {
        console.log("downloadFile", url, fileName);
        let token;
        if (global.loginUser && global.loginUser.token) {
            token = global.loginUser.token;
        }
        const x = new XMLHttpRequest();
        x.open('GET', url, true);
        x.setRequestHeader("Content-Type", "application/json");
        x.setRequestHeader("x-access-token", window.token || token);
        x.responseType = "blob";
        x.onload = () => {
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(x.response);
            a.download = fileName;
            a.click();
        };
        x.send();
    },
};

export default net; 
